// 
export const ELEMENTS = {
    A: "A",
    B: "B",
    BODY: "BODY",
    BUTTON: "BUTTON",
    DD: "DD",
    DEL: "DEL",
    DIV: "DIV",
    DL: "DL",
    DT: "DT",
    EM: "EM",
    FIELDSET: "FIELDSET",
    FIGURE: "FIGURE",
    FOOTER: "FOOTER",
    FORM: "FORM",
    H1: "H1",
    H2: "H2",
    H3: "H3",
    H4: "H4",
    H5: "H5",
    H6: "H6",
    HEAD: "HEAD",
    HEADER: "HEADER",
    HR: "HR",
    HTML: "HTML",
    I: "I",
    IFRAME: "IFRAME",
    FRAME: "FRAME",
    IMG: "IMG",
    INPUT: "INPUT",
    LABEL: "LABEL",
    LEGEND: "LEGEND",
    LI: "LI",
    LINK: "LINK",
    MAIN: "MAIN",
    NAV: "NAV",
    NOSCRIPT: "NOSCRIPT",
    OL: "OL",
    OPTION: "OPTION",
    P: "P",
    PICTURE: "PICTURE",
    SCRIPT: "SCRIPT",
    SECTION: "SECTION",
    SELECT: "SELECT",
    SMALL: "SMALL",
    SOURCE: "SOURCE",
    SPAN: "SPAN",
    STRONG: "STRONG",
    STYLE: "STYLE",
    TABLE: "TABLE",
    TBODY: "TBODY",
    TD: "TD",
    TEMPLATE: "TEMPLATE",
    TEXTAREA: "TEXTAREA",
    TFOOT: "TFOOT",
    TH: "TH",
    THEAD: "THEAD",
    TITLE: "TITLE",
    TR: "TR",
    UL: "UL",
    VIDEO: "VIDEO",
};

export const PARAMETER_EVENT = {
    TOGGLE: "toggle",
    ONLOAD: "onLoad",
    REMOVE: "remove",
    BLOCK: "block",
    NONE: "none",
    PLUS: "plus",
    MINUS: "minus",
    CLOSE: "close",
    OPEN: "open",
    LEFT: "left",
    RIGHT:"right"
}

export const WIDGET_CLASS_ATTRIBUTES = {
    NEW_TAB_WARNING: "(opens in a new tab)",
    HREF_JS_VOID: "javascript:void(0)",
    ACITIVEICON: "activeIcon",
    ACCESSIBILITY_READMODE_HIDE: "accessibility-Read-mode-hide",
    ACCESSIBILITY_STYLE: "accessibility-style",
    ACCESSIBILITY_FONTSIZE: "accessibility-fontSize",
    ACCESSIBILITY_TOOLTIP: "accessibility-tooltip",

}

export const MATCH_COLOR = ["rgb(0, 118, 180)", "rgb(122, 84, 156)", "rgb(200, 55, 51)", "rgb(208, 112, 33)", "rgb(38, 153, 159)", "rgb(77, 120, 49)", "rgb(255, 255, 255)", "rgb(0, 0, 0)"]
export const TEXT_COLOR_ELEMENTS = "body p:not(#progatixWidget p),body a:not(#progatixWidget a),body li:not(#progatixWidget li), body span:not(#progatixWidget span),body ul:not(#progatixWidget ul), body label:not(#progatixWidget label),body ol:not(#progatixWidget ol),body button:not(#progatixWidget button),body marquee:not(#progatixWidget marquee),body small:not(#progatixWidget small),body td:not(#progatixWidget td),body strong:not(#progatixWidget strong),body i:not(#progatixWidget i),body b:not(#progatixWidget b),body dd:not(#progatixWidget dd),body dt:not(#progatixWidget dt),body dl:not(#progatixWidget dl)";
export const TITLE_COLOR_ELEMENTS = "body h1:not(#progatixWidget h1),body h2:not(#progatixWidget h2),body h3:not(#progatixWidget h3),body h4:not(#progatixWidget h4),body h5:not(#progatixWidget h5),body h6:not(#progatixWidget h6),body th:not(#progatixWidget th)";
export const BACKGROUND_COLOR_ELEMENTS = "body:not(#progatixWidget),body section:not(#progatixWidget section),body main:not(#progatixWidget main),body header:not(#progatixWidget header),body nav:not(#progatixWidget nav),body footer:not(#progatixWidget footer),body form:not(#progatixWidget form)";
export const HEADING_ELEMENTS = "body h1:not(#progatixWidget h1), body h2:not(#progatixWidget h2), body h3:not(#progatixWidget h3), body h4:not(#progatixWidget h4), body h5:not(#progatixWidget h5), body h6:not(#progatixWidget h6)";
export const ALL_ELEMENTS = "body *:not(#progatixWidget *):not(script,noscript)";
export const ACTIONS_ELEMENTS = "body a:not(#progatixWidget a),body button:not(#progatixWidget button)";